import { buscarRelatorios } from "../../services/api-relatorios.service";
import { nomeRelatorioParaExibicao } from "../../utils/relatorioApuracao.util";

/** TXM-418 — estas 7 filhas só existem no catálogo `public.relatorios` (apuracao=true)
 * porque cada uma vira sua própria linha em relatorios_apuracao quando criada
 * automaticamente por "Apuração ICMS" (ver DetalheIcms/index.js). Nunca fazem sentido como
 * escolha MANUAL no combo "Nova apuração" — criá-las direto, fora do fluxo de ICMS_APURACAO,
 * não gera as outras abas nem preenche id_apuracao_pai. Por isso ficam de fora daqui, mesmo
 * aparecendo no catálogo; "Apuração ICMS" continua sendo a única entrada nova no combo. */
const COD_RELATORIO_FILHAS_ICMS_APURACAO = new Set([
  "ICMS_ST_CAT42",
  "NOTAS_FISCAIS_APURACAO",
  "ECD_APURACAO",
  "ECF_APURACAO",
  "ICMS_ST_APURACAO",
  "CONTRIBUICOES_APURACAO",
  "ECREDAC_SIMPLIFICADA",
]);

/** TXM-418 — o protótipo (apuracao_pis_cofins_lista.html:741, `<option value="icms">ICMS</option>`)
 * usa só "ICMS" no combo, não "Apuração ICMS" (o `nome` real do catálogo). Sobrescrevemos só o
 * label exibido AQUI — não o valor `nome` em public.relatorios, que outras telas usam de outra
 * forma (títulos/breadcrumb já são texto fixo "Apuração ICMS — <empresa>", não vêm do catálogo,
 * então não há inconsistência). */
const LABEL_OVERRIDE_POR_CODIGO = {
  ICMS_APURACAO: "ICMS",
};

export function normalizarTiposApuracao(relatorios) {
  return (relatorios ?? [])
    .filter((r) => !COD_RELATORIO_FILHAS_ICMS_APURACAO.has(String(r.codigoRelatorio ?? "").trim()))
    .map((r) => {
      const codigoRelatorio = String(r.codigoRelatorio ?? "").trim();
      return {
        idRelatorio: r.idRelatorio,
        codigoRelatorio,
        nome: r.nome ?? "",
        script: r.script ?? "",
        label: LABEL_OVERRIDE_POR_CODIGO[codigoRelatorio] ?? nomeRelatorioParaExibicao(r.nome),
      };
    })
    .sort((a, b) =>
      String(a.label).localeCompare(String(b.label), "pt-BR", { sensitivity: "base" })
    );
}

export async function fetchTiposApuracao() {
  const response = await buscarRelatorios({ apuracao: true });
  return normalizarTiposApuracao(response?.relatorios ?? []);
}
